module.exports = "<ul class=\"nav d-none d-md-flex\">\r\n\t<li class=\"nav-item\" *ngFor=\"let item of menuItems\">\r\n\t\t<a class=\"nav-link\" [routerLink]=\"[item.url]\">{{item.name}}</a>\r\n\t</li>\r\n\t<li class=\"nav-item\">\r\n\t\t<a class=\"nav-link\" [href]=\"AUKRO_URL + '/kontakt/prodej-dalsi-sluzby/potize-s-manazerem-prodeje'\" i18n>Kontakt</a>\r\n\t</li>\r\n</ul>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-nav-menu-footer.component.html
// module id = 470
// module chunks = 11